module.exports = __webpack_public_path__ + "img/shi_ztb.72a94f9c.png";